import { Modal, Button, Typography, Box } from '@mui/material';
import { useState } from 'react';

interface EditCustomerDialogProps {
  isOpen: boolean;
  onDialogDecision: (result: boolean) => void;
  currentCustomer: string;
  newAbgMasterName: string;
}

export default function UpdateNameChangeConfirmation({
  isOpen,
  onDialogDecision,
  currentCustomer,
  newAbgMasterName,
}: EditCustomerDialogProps) {
  const [open, setOpen] = useState(isOpen);

  const handleDecision = (result: boolean) => {
    onDialogDecision(result); // Pass the result to the parent and wait for resolution
    handleClose();
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onClose={() => handleClose()}
      aria-labelledby='update-name-change-confirmation'
      aria-describedby='confirmation-of-updating-name-change-request'
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography id='alert-dialog-description' sx={{ mt: 2 }}>
          {`A name change request already exists involving ${currentCustomer}. The pending name change is to change ${currentCustomer} to ${newAbgMasterName}. 
          Continuing with creating this request will delete this active request. Do you want to continue? 
          `}
        </Typography>
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={() => handleDecision(false)} color='primary' variant='outlined' sx={{ mr: 2 }}>
            Cancel
          </Button>
          <Button onClick={() => handleDecision(true)} color='primary' variant='contained'>
            Continue
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
